import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.css";
import arrowwhite from "../../assets/images/arrow-white.svg";
import { authActions } from "../../_actions";
import { useDispatch, useSelector } from "react-redux";
import { status } from "../../_constants";
import { alert } from "../../_utilities";

function Login() {
  const location = useLocation();
  const { state } = location || {};

  const [emailOrNumber, setEmailOrNumber] = useState("");
  const [isEmailMode, setIsEmailMode] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");
  const registerData = useSelector((state) => state.auth);
  const inputRef = useRef(null);

  function validateEmailOrContact(isSubmited) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // const contactNumberRegex = /^[1-9]\d{9,14}$|^\d{10,12}$/;
    const contactNumberRegex = /^\d{10,12}$/;
    let validate = false;
    if (isSubmited) {
      if (isEmailMode) {
        // In email mode, only validate email
        if (emailRegex.test(emailOrNumber)) {
          setErrorMessage("");
          validate = true;
        } else {
          setErrorMessage("Enter a valid email address!");
          validate = false;
        }
      } else {
        // In phone mode, validate both email and phone
        if (emailRegex.test(emailOrNumber)) {
          setErrorMessage("");
          validate = true;
        } else if (contactNumberRegex.test(emailOrNumber)) {
          setErrorMessage("");
          validate = true;
        } else {
          setErrorMessage("Enter a valid input!");
          validate = false;
        }
      }
    }
    return validate;
  }

  // useEffect(() => {
  //   const savedUser = localStorage.getItem("user");
  //   if (savedUser && !isEmailMode) {
  //     setEmailOrNumber(savedUser);
  //   }
  // }, [isEmailMode]);

  useEffect(() => {
    if (emailOrNumber && !isEmailMode) {
      localStorage.setItem("user", emailOrNumber);
    }
  }, [emailOrNumber, isEmailMode]);

  useEffect(() => {
    if (
      registerData &&
      registerData.registration_data &&
      registerData.register_status === status.SUCCESS
    ) {
      localStorage.setItem("user", emailOrNumber);
      setEmailOrNumber("");
      navigate("/verification", {
        state: state,
      });
    } else {
      if (
        registerData &&
        registerData.registration_data &&
        registerData.registration_data.errors
      ) {
        const errorCode = registerData.registration_data.errors.error_code;
        if (errorCode === "OTP_SEND_FAILED") {
          // Clear stored user data
          localStorage.removeItem("user");
          setEmailOrNumber("");
          setIsEmailMode(true);
        }
      }
    }
  }, [registerData.registration_data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // const contactNumberRegex = /^[1-9]\d{9,14}$|^\d{10,12}$/;
    const contactNumberRegex = /^\d{10,12}$/;
    if (validateEmailOrContact(true)) {
      if (emailRegex.test(emailOrNumber)) {
        dispatch(authActions.register({ email: emailOrNumber }));
      } else if (contactNumberRegex.test(emailOrNumber) && !isEmailMode) {
        dispatch(authActions.register({ phone: emailOrNumber }));
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  window.onload = function () {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  window.onclick = function () {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div className="main-wrapper" id="sign-up">
      <div className="container">
        <div className="signup-page">
          <div className="text-content">
            <h2>
              {isEmailMode
                ? "What's your email address?"
                : "What's your phone number?"}
            </h2>
          </div>
          <div className="form-group-blue">
            <input
              type={isEmailMode ? "email" : "tel"}
              name="emailOrNumber"
              value={emailOrNumber}
              placeholder={
                isEmailMode ? "Enter email address" : "Enter phone number"
              }
              // onChange={(e) => setEmailOrNumber(e.target.value)}
              onChange={(e) => {
                const value = e.target.value;
                if (isEmailMode) {
                  // Allow any input for email
                  setEmailOrNumber(value);
                } else {
                  // Only allow digits for phone number
                  if (
                    value === "" ||
                    (value.length <= 12 && /^\d+$/.test(value))
                  ) {
                    setEmailOrNumber(value);
                  }
                }
              }}
              onKeyDown={handleKeyDown}
              ref={inputRef}
            />
            {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
          </div>
          <div className="Continue-btn">
            <button
              title="Continue"
              className="primary-btn sm Continue"
              onClick={handleSubmit}
            >
              Continue
              <span>
                <img src={arrowwhite} alt="" />
              </span>
            </button>
          </div>
          <p>
            {isEmailMode
              ? "By proceeding, you consent to receive emails from SumoEats and its affiliates to the email address provided."
              : "By proceeding, you consent to get calls, WhatsApp or SMS messages, including by automated means, from SumoEats and its affiliates to the number provided."}
          </p>
        </div>
      </div>
    </div>
  );
}
export default Login;
